import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SV_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#SV_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "SV_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#SV_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0zM0 16v8h32v-8H0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.426 11.859a3.642 3.642 0 11-7.283 0 3.642 3.642 0 017.283 0z",
      stroke: "#E8AA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.81 9.662s-.953 1.568-.953 2.644 1.14 2.429 2.934 2.429c1.75 0 3.008-1.045 3.046-2.429.038-1.384-.941-2.369-.941-2.369s.554 1.992.277 2.8c-.277.807-1.174 1.784-2.381 1.66-1.208-.125-2.353-1.611-2.353-2.091 0-.48.371-2.644.371-2.644z",
      fill: "#1E601B"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M14.16 12.328h3.207", stroke: "#188396" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.459 11.806h2.76M17.05 12.411h-2.456l1.24-2.056 1.216 2.056z",
      stroke: "#E8AA00"
    }
  )))
), a = t;
export {
  a as default
};
